import React, { useState } from 'react';
import { sendEmailVerification, signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { Button } from '../components/UI';

export default function EmailVerificationScreen({ user, onVerificationComplete }) {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleResend = async () => {
        setLoading(true);
        setError('');
        setMessage('');
        try {
            await sendEmailVerification(user);
            setMessage('Email verifikasi telah dikirim ulang! Silakan periksa kotak masuk (Inbox/Spam) Anda.');
        } catch (err) {
            console.error("Gagal mengirim ulang email:", err);
            setError('Gagal mengirim email. Tunggu beberapa saat sebelum mencoba lagi.');
        } finally {
            setLoading(false);
        }
    };

    const handleCheckVerification = async () => {
        setLoading(true);
        setError('');
        setMessage('');
        try {
            await user.reload(); // Force Firebase to reload user profile
            if (auth.currentUser.emailVerified) {
                setMessage('Berhasil! Akun Anda telah diverifikasi.');
                setTimeout(() => {
                    onVerificationComplete();
                }, 1500);
            } else {
                setError('Email belum terverifikasi. Silakan klik tautan di email yang kami kirimkan.');
            }
        } catch (err) {
            console.error("Gagal memeriksa status:", err);
            setError('Terjadi kesalahan saat memeriksa status verifikasi.');
        } finally {
            setLoading(false);
        }
    };

    const handleLogout = async () => {
        await signOut(auth);
    };

    return (
        <div className="min-h-screen flex flex-col justify-center items-center p-6 relative overflow-hidden bg-gradient-to-br from-teal-50 via-sky-50 to-purple-50">
            {/* Animated Background */}
            <div className="absolute top-0 left-0 w-64 h-64 bg-purple-300 rounded-full  blur-3xl opacity-40  pointer-events-none"></div>
            <div className="absolute -bottom-8 right-20 w-64 h-64 bg-teal-300 rounded-full  blur-3xl opacity-40   pointer-events-none"></div>

            <div className="relative z-10 w-full max-w-md">
                <div className="bg-white/90 backdrop-blur-xl rounded-[2.5rem] shadow-[0_8px_30px_rgb(0,0,0,0.08)] p-8 sm:p-10 text-center border border-white/60">
                    <div className="w-24 h-24 bg-teal-50 text-teal-600 rounded-full mx-auto flex items-center justify-center mb-6 shadow-sm border border-teal-100 animate-bounce-slow">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                    </div>

                    <h1 className="text-3xl font-extrabold text-brand-dark mb-4">Verifikasi Email Anda</h1>
                    <p className="text-brand-muted text-sm leading-relaxed mb-8">
                        Kami telah mengirimkan tautan verifikasi ke:
                        <br />
                        <span className="font-bold text-gray-800 text-base">{user.email}</span>
                        <br /><br />
                        Silakan periksa kotak masuk atau folder spam Anda, lalu klik tautan tersebut untuk mengaktifkan akun.
                    </p>

                    {error && (
                        <div className="bg-red-50 text-red-600 p-4 rounded-xl mb-6 text-sm font-medium border border-red-100">
                            {error}
                        </div>
                    )}
                    {message && (
                        <div className="bg-green-50 text-green-700 p-4 rounded-xl mb-6 text-sm font-medium border border-green-100">
                            {message}
                        </div>
                    )}

                    <div className="space-y-4">
                        <Button onClick={handleCheckVerification} disabled={loading} className="w-full shadow-lg">
                            {loading ? 'Memeriksa...' : 'Saya Sudah Verifikasi'}
                        </Button>
                        <button 
                            onClick={handleResend} 
                            disabled={loading}
                            className="w-full py-4 rounded-[1.25rem] bg-white border border-gray-200 text-gray-700 font-bold hover:bg-gray-50 transition-all duration-300"
                        >
                            Kirim Ulang Email
                        </button>
                    </div>

                    <div className="mt-8 pt-6 border-t border-gray-100">
                        <button 
                            onClick={handleLogout}
                            className="text-sm font-semibold text-gray-500 hover:text-red-500 transition-colors"
                        >
                            Kembali ke Halaman Login
                        </button>
                    </div>
                </div>
            </div>

            <style>{`
                
                    33% { transform: translate(30px, -50px) scale(1.1); }
                    66% { transform: translate(-20px, 20px) scale(0.9); }
                    100% { transform: translate(0px, 0px) scale(1); }
                }
                . { animation: blob 7s infinite; }
                . { animation-delay: 2s; }
                @keyframes bounce-slow {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-10px); }
                }
                .animate-bounce-slow { animation: bounce-slow 3s infinite ease-in-out; }
            `}</style>
        </div>
    );
}
